<style lang="scss">
.help {
  &__title {
    font-size: 26 / 16 + rem;
    font-weight: 500;
    margin-bottom: 14 / 16 + rem;
  }
  &__sub {
    font-size: 14 / 16 + rem;
    display: flex;
  }
  margin-bottom: 30 / 16 + rem;
}
sup {
  font-size: .5rem;
  margin-bottom: .8rem !important;
  color: red;
  font-weight: 500;
}
ol.for-sup {
  margin: 2rem 0 0 1rem;
  list-style-type:decimal;
  font-size: .8rem;
  font-weight: 500;
  line-height: 1rem;
  li {
    padding: 1rem 1rem 0 0;
    color: red; /* Цвет маркеров */
    span {
      color: #333; /* Цвет текста */
    }
  }
}
.brand {
  &.visa {
    width: 80px;
    height: 25px;
    background: url('~@/assets/img/cards/visa.svg') no-repeat;
    background-size: cover;
  }
  &.mastercard,
  &.master {
    width: 80px;
    height: 61px;
    background: url('~@/assets/img/cards/mastercard.svg') no-repeat;
    background-size: cover;
  }
  &.belcard {
    width: 80px;
    height: 60px;
    background: url('~@/assets/img/cards/belkart.svg') no-repeat;
    background-size: cover;
  }
}
</style>

<template lang="pug">
section.visible__layout
  h1.h1-title {{ $t('common.myCards') }}

  spacer(size="40px")

  .tab-controls
    button.tab-controls__item(@click="active = 0;", :class="{ 'active': active === 0 }")
      span.tab-controls__item__title {{ $t('clientCards') }}
      span.tab-controls__item__anchor
    button.tab-controls__item(@click="active = 1;", :class="{ 'active': active === 1 }")
      span.tab-controls__item__title {{ $t('payCards') }}
      span.tab-controls__item__anchor

  // spacer(size="50px")

  div
    //- !!empty commit!!.row
      .row-objects_cat
        a.button.button_secondary-round.uppercase.semi-bold(@click="active=0;",
        href="#", :class="{ 'active': active == 0 }") Карты клиента
      .row-objects_cat
        a.button.button_secondary-round.uppercase.semi-bold(@click="active=1;",
        href="#", :class="{ 'active': active == 1 }") Платежные карты
    .tabs
      .tab(v-if="active==0")
        //- .column(v-if="cardCode && cardCode.length")
        //-   .help
        //-     // .help__sub {{ $t('cards.isCardCode') }}
        //-   .row
        //-     vb-card(:code="cardCode", @delete="deleteCardCode")

        .column
          .help(style="margin-bottom:.625rem;")
            .help__title {{ $t('cards.noCardCodeTitle') }}
            // .help__sub {{ $t('cards.noCardCodeSub') }}
              sup 1
          .row
            // button.btn.button_secondary-outline(:disabled="waitCardCode",
                @click="addCardCode"
              ) {{ $t('cards.bonusCard') }}
                sup 3
            button.btn.button_secondary-outline(:disabled="waitCardCode",
              @click="isCodeOpen = true;"
            ) {{ $t('cards.linkCard') }}
              // sup 2
          // .row
            ol.for-sup
              li
                span Подробная информация о правилах посещения мероприятия с использованием Карты
                  | &nbsp;клиента указана в смс и/или email уведомлении, которое Вы получите при
                  | &nbsp;оформлении заказа
              li
                span Возможно добавление только банковской карты MasterCard Gold "Белинвестбанка",
                  | &nbsp;выпущенной при сотрудничистве с ФК "Динамо-Брест". Для добавления карты
                  | &nbsp;необходимо ввести номер штрихкода, расположенного на обратной стороне
                  | &nbsp;банковской карты. После добавления вы сможете пользоваться кар
                  | той в качестве
                  | &nbsp;билета при посещении мероприятий
              li
                span Создание Виртуальной карты 24afisha. Карта создается автоматически. После
                  | &nbsp;добавления вы сможете предъявить карту с мобильного телефона в качестве
                  | &nbsp;билета при посещении мероприятий

        // spacer(size="50px")
        .column(v-if="bindingCards && bindingCards.length")
          .row(v-for="card in bindingCards")
            vb-card(:code="card.code", :image="card.binding_card.image", :name="card.binding_card.name", @delete="deleteCardCode")

        transition(name="fade" mode="out-in")
          input-dialog(v-if="isCodeOpen",
          :placeholder="`${$t('cards.enterNumber')}`",
            @submit="assignCardCode", @close="isCodeOpen = false;"
          )
            template(#helper) {{$t('cards.enterBarcode')}}
            template(#title) {{$t('cards.linkingCard')}}
            template(#button) {{ $t('common.assign') }}

      .tab(v-if="active==1")
        .tab__content
          .payment__list(v-if="cards && cards.length")
            .payment__list_items
              .payment__list_items--item(v-for="card in cards")
                .payment__part
                  .brand(:class="card.brand")
                  .payment__part-title {{card.card_number}}
                  .payment__part-title {{card.month}} / {{card.year}}
                  .payment__part-title {{card.brand}}
                .payment__part
                  .payment__part-link
                    button.btn.button_primary-outline(@click="wantRmCredit(card)") {{$t('cards.delete')}}
          .no-orders(v-else)
            .no-orders__message
              i.grey-ticket
              .label {{$t('cards.noLinkedCards')}}

    transition(name="fade" mode="out-in")
      vb-dialog(v-model="credit.show", @reject="rejectRmCredit", @resolve="successRmCredit")
        template(#title) {{$t('cards.removingCard')}} {{ credit.card.brand }}
        template(#default) {{$t('cards.sureToDelete')}} <b>{{ credit.card.card_number }}</b>

    transition(name="fade" mode="out-in")
      vb-dialog(v-model="wantDelete", @reject="wantDelete = false;", @resolve="rmCardCode")
        template(#title) {{$t('cards.removingCustomerCard')}}
        template(#default) {{$t('cards.sureToDeleteCustomer')}} <b>№{{ cardCode }}</b>

    transition(name="fade" mode="out-in")
      vb-dialog(v-model="wantVirt", @reject="wantVirt = false;", @resolve="newCardCode")
        template(#title) {{$t('cards.confirmAction')}}
        template(#default) {{$t('cards.virtualCard')}}
</template>

<script>
import { mapGetters } from 'vuex';
import Skeleton from '@/components/Skeleton';
import API from '@/api/api';

export default {
  components: {
    Skeleton,
  },
  data() {
    return {
      wantDelete: false,
      wantVirt: false,
      active: 0,
      cards: [],
      bindingCards: [],
      isCodeOpen: false,
      waitCardCode: false,

      credit: {
        show: false,
        card: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      cardCode: 'cardCode',
    }),
  },
  mounted() {
    this.getCards();
    this.getBindingCards();
  },
  methods: {
    wantRmCredit(card) {
      this.credit.card = card;
      this.credit.show = true;
    },
    rejectRmCredit() {
      this.credit.show = false;
      this.credit.card = null;
    },
    async successRmCredit() {
      try {
        const data = await API.deleteCard(this.credit.card.id);
        if (data) {
          this.getCards();
          this.credit.show = false;
          this.credit.card = null;
        }
      } catch (e) {
        console.log(e);
        global.alert('Произошла ошибка, попробуйте позже!');
      }
    },

    newCardCode() {
      this.waitCardCode = true;
      API.cardCode().then((response) => {
        const { code = null } = response;
        this.$store.commit('cardCode', code);
        this.waitCardCode = false;
      }).catch((error) => {
        global.console.error(error);
        global.alert('Произошла ошибка, попробуйте позже!');
      });
    },

    deleteCardCode() {
      this.wantDelete = true;
    },

    addCardCode() {
      this.wantVirt = true;
    },

    rmCardCode() {
      this.waitCardCode = true;
      API.deleteCardCode().then((response) => {
        if (response.status) {
          this.$store.commit('cardCode', null);
        }
        this.waitCardCode = false;
      }).catch((error) => {
        global.console.error(error);
        global.alert('Произошла ошибка, попробуйте позже!');
      });
    },

    assignCardCode(code) {
      if (code.length <= 0) {
        return;
      }
      API.cardCode(code).then((response) => {
        const { code = null } = response;
        this.$store.commit('cardCode', code);
        this.isCodeOpen = false;
        this.getBindingCards();
      }).catch((error) => {
        global.console.error(error);
        const { response: { status, data } = {} } = error;
        if (status === 500) {
          global.alert('Произошла ошибка сервера, попробуйте позже!');
          return;
        }
        const { errors: { code: [err = 'Непредвиденная ошибка'] = [] } = {} } = data;
        global.alert(err);
      });
    },

    async getCards() {
      const data = await API.getCards();
      if (data && data.data) {
        this.cards = data.data;
      }
    },

    async getBindingCards() {
      const data = await API.getBindingCards();
      if (data && data.data) {
        this.bindingCards = data.data;
      }
    },

    async deleteCard(id) {
      const data = await API.deleteCard(id);
      if (data) {
        this.getCards();
      }
    },
  },
};
</script>
